import React from 'react';
import * as ReactToastr from 'react-toastr';
import { connect } from 'react-redux';

const { ToastContainer, ToastMessage } = ReactToastr;
import {bindActionCreators} from "redux";
import * as authActionCreator from "../actions/authactions";
var ToastMessageFactory = React.createFactory(ToastMessage.animation);

class CoreLayout extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            loading:true
        }
    }

    async componentDidMount(){
        const vars = {};
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        let samlToken = vars.auth_token;
        if(samlToken){
            samlToken = samlToken.substring(0,samlToken.indexOf("#"));
            await this.props.actions.getMeUser(samlToken);
            let URL = window.location.href;
            URL = URL.substring(0,URL.indexOf("?"));
            window.location.href = URL;
            this.setState({loading:false});
        }else if(vars.sso_failure){
            this.props.actions.showSAMLError("Error while signing with GSuite, please try again or contact administrator");
            this.setState({loading:false});
        }else{
            this.setState({loading:false});
        }

    }
    componentDidUpdate(prevProps) {
        if (this.props.toast && this.props.toast.show === true && this.props.toast !== prevProps.toast) {
            if (this.props.toast.toastData && this.refs.container) {
                if (this.props.toast.toastData.status === 'error') {
                    this.refs.container.error(
                        this.props.toast.toastData.message, this.props.toast.toastData.title, {
                            timeOut: 3000,
                            extendedTimeOut: 1000,
                            showDuration: "300",
                            hideDuration: "1000",
                            showEasing: "swing",
                            hideEasing: "linear",
                            showMethod: "fadeIn",
                            hideMethod: "fadeOut"
                        });
                } else if (this.props.toast.toastData.status === 'success') {
                    this.refs.container.success(
                        this.props.toast.toastData.message, this.props.toast.toastData.title, {
                            timeOut: 3000,
                            extendedTimeOut: 1000,
                            showDuration: "300",
                            hideDuration: "1000",
                            showEasing: "swing",
                            hideEasing: "linear",
                            showMethod: "fadeIn",
                            hideMethod: "fadeOut"
                        });
                }
            }
        }
    }
    render() {
        const {loading} = this.state;

        return (
            <div>
                <ToastContainer ref="container"
                                toastMessageFactory={ToastMessageFactory}
                                className="toast-top-right"
                                iconClassName="error"/>
                {loading ? <div/> : this.props.children}
            </div>

        );
    }
}


const mapStateToProps = (state) => ({
    toast: state.toast
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(authActionCreator, dispatch)
});


export default connect(mapStateToProps,mapDispatchToProps)(CoreLayout);
